// extracted by mini-css-extract-plugin
module.exports = {"bubble":"S2-2_Testimonials_bubble__vI1ac"};